import { Controller } from "@hotwired/stimulus";
import { onlyDigits, formatCep, isValidCepDigits } from "../../modules/crud/consulta_cep/helpers";

// REAPROVEITA do CPF (consulta_ws)
import { lockScreen } from "../../modules/crud/consulta_ws/overlay";
import { setFormDisabled } from "../../modules/crud/consulta_ws/form_disable";

import { applyCepResponseToForm } from "../../modules/crud/consulta_cep/mapper";

export default class extends Controller {
  lookup() {
    const $input = $j(this.element);
    const $form = $input.closest("form");

    const raw = ($input.val() || "").toString();
    const digits = onlyDigits(raw);

    if (!digits) return;

    if (!isValidCepDigits(digits)) {
      console.warn("[consulta_cep] CEP inválido:", raw);
      return;
    }

    const url = $input.data("source");
    if (!url) {
      console.error("[consulta_cep] data-source não encontrado no input");
      return;
    }

    // garante formato no campo antes de consultar
    $input.val(formatCep(digits));

    lockScreen(true);
    setFormDisabled($j, $form, true, { keepReadonly: true });

    $j.ajax({
      url: url,
      type: "GET",
      data: { cep: digits },
      success: (response) => {
        try {
          const dados = (response && response.dados) ? response.dados : {};
          applyCepResponseToForm($j, $form, dados, { input: $input });

          document.dispatchEvent(new CustomEvent("protel:cep_resolvido", {
            detail: {
              cep: dados.zipcode || formatCep(digits),
              endereco: dados.street || "",
              bairro: dados.neighborhood || "",
              complemento: (dados.complement || dados.complemento || ""),
              municipio: (dados.city || "")
            }
          }));
        } catch (e) {
          console.error("[consulta_cep] erro ao processar resposta:", e);
        }
      },
      error: (error) => {
        console.error("[consulta_cep] erro ajax:", error);
      },
      complete: () => {
        setFormDisabled($j, $form, false, { keepReadonly: true });
        lockScreen(false);
      }
    });
  }
}
